module.exports = __webpack_public_path__ + "img/44_bohle.109b0c8f.jpeg";